import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../App";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Check if already authenticated
    const checkAuth = async () => {
      try {
        await axios.get(`${API}/auth/me`, { withCredentials: true });
        // Already authenticated, redirect to dashboard
        navigate("/admin", { replace: true });
      } catch (error) {
        // Not authenticated, show login
        setChecking(false);
      }
    };
    checkAuth();
  }, [navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-[#0E0E0E] flex items-center justify-center">
        <div className="text-[#F5F4EF]">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0E0E0E] flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-3 mb-8 mx-auto">
            <img 
              src="/orchestrio-logo.png" 
              alt="Orchestrio" 
              className="h-8 w-auto"
            />
            <span className="text-xs font-medium text-[#8A8A8A] uppercase tracking-wider">Console</span>
          </Link>
          <h1 className="text-xl font-bold mb-2">Sign in to Console</h1>
          <p className="text-sm text-[#8A8A8A]">Access requires team authentication</p>
        </div>

        <div className="bg-[#1C1C1C] border border-[#2E2E2E] p-8">
          <button
            onClick={handleLogin}
            className="w-full btn-primary flex items-center justify-center gap-3"
            data-testid="google-login-btn"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Continue with Google
          </button>

          <p className="text-xs text-[#6B7280] text-center mt-6">
            Authorised team members only
          </p>
        </div>

        <div className="text-center mt-8">
          <Link to="/" className="text-sm text-[#8A8A8A] hover:text-[#F5F4EF] transition-colors">
            Return to main site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
